module.exports = __webpack_public_path__ + "static/media/icon_payment.25fb287e.svg";